import Swal from "sweetalert2";
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { Field, Form } from 'react-final-form';
import React, { useEffect, useState } from 'react';
import { Button } from '@/shared/components/Button';
import AdminInterface from '@/utils/AdminInterface';
import { ResolutionLabels } from '../../../../../Enums';
import withReactContent from "sweetalert2-react-content";
import renderSelectField from '@/shared/components/form/Select';
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField, FormGroupLabel } from '@/shared/components/form/FormElements';

const NewCropRequestPrice = (props) => {
  const [collectionsList, setCollectionsList] = useState();

  const submitCropRequestPrice = (values) => {
    values.collection_id = values.collection_id.value;
    values.resolution = values.resolution.value;
    AdminInterface.instance.createCropRequestPrice(values).then(() => {
      withReactContent(Swal).fire({
        title: "Success",
        html: "New crop request price is created!",
      });
      props.setListRequiresReload(true);
    }).catch((error) => {
      withReactContent(Swal).fire({
        title: "Error",
        html: error.response?.data?.detail,
      });
    });
  }

  useEffect(() => {
    AdminInterface.instance.getCollections().then((response) => {
      setCollectionsList(response.data)
    }).catch((error) => {
      withReactContent(Swal).fire({
        title: "Error",
        html: error.response?.data?.detail,
      });
    });
  }, [])

  return (
    <Col md={12}>
      <Card>
        <CardBody>
          <CardTitleWrap>
            <CardTitle>New Crop Request Price</CardTitle>
          </CardTitleWrap>
          {collectionsList && <Form onSubmit={submitCropRequestPrice} initialValues={{ collection_id: { value: collectionsList[0].id, label: collectionsList[0].name }, resolution: { value: 1, label: "1" } }}>
            {({ handleSubmit, form }) => (
              <FormContainer horizontal onSubmit={handleSubmit}>
                <FormGroup>
                  <FormGroupLabel>Collection</FormGroupLabel>
                  <FormGroupField>
                    <Field name="collection_id" component={renderSelectField}
                      options={Object.keys(collectionsList).map(function (collection) {
                        return { value: collectionsList[collection].id, label: collectionsList[collection].name }
                      })}
                    />
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>Resolution</FormGroupLabel>
                  <FormGroupField>
                    <Field name="resolution" component={renderSelectField}
                      options={Object.keys(ResolutionLabels).map(function (key) {
                        return { value: key, label: ResolutionLabels[key] }
                      })}
                    />
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>Old Assets Price (CAD ¢/KM2)</FormGroupLabel>
                  <FormGroupField>
                    <Field name="oldAssetPrice" component="input" type="text" placeholder="25000" />
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>New Assets Price (CAD ¢/KM2)</FormGroupLabel>
                  <FormGroupField>
                    <Field name="newAssetPrice" component="input" type="text" placeholder="25000" />
                  </FormGroupField>
                </FormGroup>
                <FormButtonToolbar>
                  <Button variant="primary" type="submit">Submit</Button>
                  <Button variant="secondary" type="button" onClick={form.reset}>
                    Cancel
                  </Button>
                </FormButtonToolbar>
              </FormContainer>
            )}
          </Form>}
        </CardBody>
      </Card>
    </Col>
  );
};

NewCropRequestPrice.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default NewCropRequestPrice;